import React from 'react';
import { PageTitle } from '@cordata/buffet';

import RemindersForm from '~/components/Reminder/Form';

const RemindersAdd = () => (
  <>
    <PageTitle>Add Reminder</PageTitle>

    <RemindersForm />
  </>
);

export default RemindersAdd;
